import { render, staticRenderFns } from "./RetellChatTest.vue?vue&type=template&id=2568af96&scoped=true"
import script from "./RetellChatTest.vue?vue&type=script&lang=js"
export * from "./RetellChatTest.vue?vue&type=script&lang=js"
import style0 from "./RetellChatTest.vue?vue&type=style&index=0&id=2568af96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2568af96",
  null
  
)

export default component.exports